<p-button
  severity="secondary"
  [outlined]="true"
  icon="ri ri-flashlight-fill"
  i18n-label="@@functions"
  label="Funktionen"
  i18n-pTooltip="@@supervisor-functions-exec-tooltip"
  pTooltip="Supervisor-Funktion ausführen"
  (onClick)="this.buildMenuItems(); menu.toggle($event)"
  [disabled]="this.disabled() || this.rss.botConfig.supervisorFunctions.length === 0"
></p-button>
<p-menu
  #menu
  appendTo="body"
  [model]="this.menuItems"
  [popup]="true"
/>